<script>
import { mapGetters } from 'vuex'
import ChargeResource from '@/resources/charge'
import TermsOfServiceLink from '../../components/TermsOfServiceLink.vue'

export default {
    name: 'AccountSubscription',
    components: { TermsOfServiceLink },
    computed: {
        ...mapGetters(['userResource', 'isApexClub', 'creditsBalance'])
    },
    methods: {
        async onUnenrollSubscription() {
            this.$refs.cancelSubscription.hide()
            await ChargeResource.creditUnenrollUser()
            this.userResource.set('credits_subscription_in_good_standing', false)
        },
        nthDayOfMonth(day) {
            const moment = require('moment')
            return moment(day, 'D').format('Do')
        }
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Abonnement</h4>
            <p class="text-muted mb-0">Gérez votre adhésion à {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }}.</p>
        </div>

        <b-card v-if="userResource.attributes.credits_subscription_in_good_standing">
            <dl class="row mb-0">
                <dt class="col-sm-4">Apex Club</dt>
                <dd class="col-sm-8"><strong class="text-success"><b-icon icon="patch-check-fill" /> Membre</strong></dd>
                <dt class="col-sm-4">Solde de crédits</dt>
                <dd class="col-sm-8"><strong><b-icon icon="currency-exchange" /> {{ creditsBalance }} Crédits</strong></dd>
                <dt class="col-sm-4">Abonnement</dt>
                <dd class="col-sm-8">
                    <strong><b-icon icon="arrow-repeat" /> {{ userResource.attributes.credits_recurring }} crédits mensuels le {{ nthDayOfMonth(userResource.attributes.credits_cycle_day_of_month) }} — {{ currencySymbol() }}{{ moneyFormat(userResource.attributes.credits_recurring_cents) }}</strong>
                </dd>
            </dl>
            <template #footer>
                <small><a href="javascript:{};" class="text-muted" @click="$refs.cancelSubscription.show()">Annuler l'abonnement</a></small>
            </template>
        </b-card>

        <b-alert variant="danger" show v-else-if="!userResource.attributes.credits_subscription_in_good_standing && userResource.attributes.credits_subscription_exists">
            <strong>Oh non !</strong> Votre adhésion à {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} n'est pas en règle. Veuillez
            <router-link :to="{ name: 'accountPayment' }">vérifier votre méthode de paiement</router-link> pour résoudre ce problème.
        </b-alert>

        <b-alert variant="info" show v-else>
            <strong>Économisez 20% sur chaque course</strong> en rejoignant <strong>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }}</strong>. (Et bien plus encore !)
            <router-link :to="{ name: 'subscription' }">Plus d'infos</router-link>
        </b-alert>

        <b-modal
            title="Annuler l'abonnement"
            ref="cancelSubscription"
            @ok="onUnenrollSubscription()"
            :ok-disabled="!userResource.attributes.credits_subscription_cancelable"
            cancel-title="Ne pas annuler"
            cancel-variant="primary"
            ok-title="Annuler l'abonnement"
            ok-variant="danger"
            centered
            no-fade>
            <p>Êtes-vous sûr de vouloir annuler votre abonnement ? Cette action est irréversible.
                <span v-if="creditsBalance > 0"> <strong>Vous perdrez votre solde de {{ creditsBalance }} Crédits !</strong> Envisagez d'utiliser vos crédits avant d'annuler.</span>
            </p>
            <b-alert variant="danger" :show="!userResource.attributes.credits_subscription_cancelable">
                <strong>Désolé, vous ne pouvez pas encore annuler</strong> — vous devez être membre pendant au moins deux cycles de facturation. Veuillez consulter nos <terms-of-service-link text="Conditions d'utilisation" el="span" />.
            </b-alert>
        </b-modal>
    </div>
</template>
